<template>
	<div class="story animate-bg" :class="article.section.toLowerCase()">
		<!-- <div class="section-badge section-badge-absolute" :class="article.section.toLowerCase()">
			{{ article.section }}
		</div> -->
		<div class="image">
			<img
				:src="getThumbnailImage(article)"
				class="img-fluid"
				loading="lazy"
			/>
		</div>
		<div class="details">
			<h5>
				{{ article.title }}
			</h5>
			<div>
				{{ article.author }} -
				{{
					new Date(article.date).toLocaleDateString(undefined, {
						month: "long",
						year: "numeric",
						day: "numeric",
					})
				}}
			</div>
		</div>
	</div>
</template>
<script setup>
// import { getThumbnailImage } from "../articles";
import { getThumbnailImage } from '@/articles';

const props = defineProps(["article"])

</script>